

export default class CarouselReviewsHome {

    constructor($view) {

        this.$view = $view;
        this.carou = this.$view.find('.carousel');
        this.toto = this.$view.find('.toto');
        this.toto.carousel();
        this.bind(this.carou);
    }

    bind(element){

      element.carousel();

    }
}